export default __webpack_public_path__ + "static/media/VB-icon-blue.deb0e29d.svg";